import React from 'react';
import Webcam from "react-webcam";
import Popup from 'reactjs-popup';

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user"
};



function Idiot() {
  return (
    <div className="App">
      <header className="App-header">
        Idiot Simulator
        <Popup
    trigger={<button className="button"> Instructions </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> Idiot Simulator </strong> </div>
        <div className="content">
          {' '}
          This simulator uses advanced artificial stupidity (AS) to display what someone would look like if they were an idiot.
          <br />
          <br />

People often tell the joke, “if you looked up idiot in the dictionary, you’d see a picture of so and so,” and other similar jokes. Well, we’ve decided to take on that challenge using machine learning, training our AI on millions of photos of stupid people. And now, using the power of AI, our algorithm will take a picture of you using your webcam and show you what you would look like as an idiot. The future of intelligent computing is incredible!
          <br />
          <br />
        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>
        <Webcam
          audio={false}
          height={900}
          screenshotFormat="image/jpeg"
          width={1200}
          videoConstraints={videoConstraints}
        />
      </header>
    </div>
  );
}

export default Idiot;
